"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_molecules_loading_1 = require("@carlsberggroup/malty.molecules.loading");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const _1 = require(".");
const Button_styled_1 = require("./Button.styled");
const Button_types_1 = require("./Button.types");
const Button = (_a) => {
    var { text, style, type = Button_types_1.ButtonType.Default, negative = false, fullWidth = false, disabled, selected = false, onClick, onKeyUp, icon, url, size = _1.ButtonSize.Medium, iconPos = Button_types_1.ButtonIconPosition.Right, loading = false, tabIndex = -1, children, dataTestId, color = Button_types_1.ButtonColor.DigitalBlack, className } = _a, props = __rest(_a, ["text", "style", "type", "negative", "fullWidth", "disabled", "selected", "onClick", "onKeyUp", "icon", "url", "size", "iconPos", "loading", "tabIndex", "children", "dataTestId", "color", "className"]);
    let Component = Button_styled_1.StyledPrimaryButton;
    let iconColor = negative ? malty_atoms_icon_1.IconColor.DigitalBlack : malty_atoms_icon_1.IconColor.White;
    switch (style) {
        case Button_types_1.ButtonStyle.Secondary:
            Component = Button_styled_1.StyledSecondaryButton;
            iconColor = negative ? malty_atoms_icon_1.IconColor.White : malty_atoms_icon_1.IconColor.DigitalBlack;
            if (!negative) {
                if (color === Button_types_1.ButtonColor.ThemePrimary) {
                    iconColor = malty_atoms_icon_1.IconColor.Primary;
                }
                if (color === Button_types_1.ButtonColor.ThemeSecondary) {
                    iconColor = malty_atoms_icon_1.IconColor.Secondary;
                }
                if (color === Button_types_1.ButtonColor.ThemeTertiary) {
                    iconColor = malty_atoms_icon_1.IconColor.Tertiary;
                }
            }
            break;
        case Button_types_1.ButtonStyle.Transparent:
            Component = Button_styled_1.StyledTransparentButton;
            iconColor = negative ? malty_atoms_icon_1.IconColor.White : malty_atoms_icon_1.IconColor.DigitalBlack;
            if (!negative) {
                if (color === Button_types_1.ButtonColor.ThemePrimary) {
                    iconColor = malty_atoms_icon_1.IconColor.Primary;
                }
                if (color === Button_types_1.ButtonColor.ThemeSecondary) {
                    iconColor = malty_atoms_icon_1.IconColor.Secondary;
                }
                if (color === Button_types_1.ButtonColor.ThemeTertiary) {
                    iconColor = malty_atoms_icon_1.IconColor.Tertiary;
                }
            }
            break;
        default:
            if (negative) {
                if (color === Button_types_1.ButtonColor.ThemePrimary) {
                    iconColor = malty_atoms_icon_1.IconColor.Primary;
                }
                if (color === Button_types_1.ButtonColor.ThemeSecondary) {
                    iconColor = malty_atoms_icon_1.IconColor.Secondary;
                }
                if (color === Button_types_1.ButtonColor.ThemeTertiary) {
                    iconColor = malty_atoms_icon_1.IconColor.Tertiary;
                }
            }
            break;
    }
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const [hPadding, _setHorizontalPadding] = (0, react_1.useState)(theme.sizes.s.value);
    const [loadingNegative, setLoadingNegative] = (0, react_1.useState)(negative);
    const handleLoadingColor = () => {
        if (style !== Button_types_1.ButtonStyle.Primary) {
            setLoadingNegative(negative);
        }
        else {
            setLoadingNegative(!negative);
        }
    };
    (0, react_1.useEffect)(() => {
        handleLoadingColor();
    }, [negative, style]);
    const renderComponent = () => (react_1.default.createElement(Component, Object.assign({ color: color, "data-testid": dataTestId, type: type, disabled: disabled, isLoading: loading, hasText: !!text || !!children, hasIcon: !!icon, horizontalPadding: hPadding, onClick: onClick, onKeyUp: onKeyUp, isNegative: negative, fullWidth: fullWidth, iconPos: iconPos, theme: theme, tabIndex: tabIndex, className: selected ? `${className} active` : className, size: size }, props),
        react_1.default.createElement("div", { className: "text-container" },
            icon && iconPos === Button_types_1.ButtonIconPosition.Left && react_1.default.createElement(malty_atoms_icon_1.Icon, { name: icon, color: iconColor, size: malty_atoms_icon_1.IconSize.Small }),
            text || children,
            icon && iconPos === Button_types_1.ButtonIconPosition.Right && react_1.default.createElement(malty_atoms_icon_1.Icon, { name: icon, color: iconColor, size: malty_atoms_icon_1.IconSize.Small })),
        loading && (react_1.default.createElement("div", { "data-testid": `${dataTestId}-loading`, className: "secondary-container" },
            react_1.default.createElement(malty_molecules_loading_1.Loading, { color: color, negative: loadingNegative, status: malty_molecules_loading_1.LoadingStatus.Pending })))));
    return url ? (react_1.default.createElement(Button_styled_1.StyledAnchor, { target: "_blank", href: url, rel: "noreferrer", className: selected ? 'active' : '' }, renderComponent())) : (renderComponent());
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map